import { useState, useContext } from 'react';
import { Play } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function StartAuditModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.startAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit démarré avec succès !');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Échec du démarrage du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error starting audit plan:', error);
      showError('Erreur lors du démarrage du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleStart}
      title="Démarrer le plan d'audit"
      message="Êtes-vous sûr de vouloir démarrer ce plan d'audit ? Vous pourrez créer des sections et des questions une fois démarré."
      confirmText={loading ? 'Démarrage en cours...' : 'Démarrer l\'audit'}
      confirmButtonClass="bg-green-600 hover:bg-green-700"
      icon={<Play className="h-6 w-6 text-green-600" />}
      loading={loading}
    />
  );
}
